// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"667":"4052c132","843":"2fe436a2"}[chunkId] + ".css";
};